/**
 * Created by amit.ashutosh on 11/21/16.
 */
import {
  TRANSACTION_LIST_REQUEST,
  TRANSACTION_LIST_SUCCESS,
  TRANSACTION_OVERVIEW_SUCCESS,
  TRANSACTION_LIST_FAILURE,

  MEMBER_ENROLLMENT_REQUEST,
  MEMBER_ENROLLMENT_SUCCESS,
  MEMBER_ENROLLMENT_FAILURE,

  MEMBER_ACCOUNTS_REQUEST,
  MEMBER_ACCOUNTS_SUCCESS,
  MEMBER_ACCOUNTS_FAILURE,

  FINANCIAL_INSTITUTIONS_REQUEST,
  FINANCIAL_INSTITUTIONS_SUCCESS,
  FINANCIAL_INSTITUTIONS_FAILURE,

  FINANCIAL_INSTITUTIONS_BY_ID_REQUEST,
  FINANCIAL_INSTITUTIONS_BY_ID_SUCCESS,
  FINANCIAL_INSTITUTIONS_BY_ID_FAILURE,

  POPULAR_FINANCIAL_INSTITUTIONS_REQUEST,
  POPULAR_FINANCIAL_INSTITUTIONS_SUCCESS,
  POPULAR_FINANCIAL_INSTITUTIONS_FAILURE,

  PAGINATE_TRANSACTIONS,
  FILTERED_TRANSACTIONS_BY_ACCOUNT_ID,

  CURRENT_DATE_SELECTION,
  CURRENT_ACCOUNT_SELECTION,

  RESET_ADD_ACCOUNTS_MODAL,
  RESET_LOGIN_FORM,
  RESET_LOGIN_ERROR,
  RESET_CHALLENGE_QUESTION,

  TXM_SET_ALERT_PREF_REQUEST,
  TXM_SET_ALERT_PREF_SUCCESS,
  TXM_SET_ALERT_PREF_FAILURE,

  ADD_INSTITUTION_LOGIN_REQUEST,
  ADD_INSTITUTION_LOGIN_SUCCESS,
  ADD_INSTITUTION_LOGIN_FAILURE,
  ADD_INSTITUTION_LOGIN_AUTH_FAILURE,

  ANSWER_ADD_INSTITUTION_LOGIN_CHALLENGE_REQUEST,
  ANSWER_ADD_INSTITUTION_LOGIN_CHALLENGE_SUCCESS,
  ANSWER_ADD_INSTITUTION_LOGIN_CHALLENGE_FAILURE,

  ANSWER_UPDATE_INSTITUTION_LOGIN_CHALLENGE_REQUEST,
  ANSWER_UPDATE_INSTITUTION_LOGIN_CHALLENGE_SUCCESS,
  ANSWER_UPDATE_INSTITUTION_LOGIN_CHALLENGE_FAILURE,

  UPDATE_INSTITUTION_LOGIN_REQUEST,
  UPDATE_INSTITUTION_LOGIN_SUCCESS,
  UPDATE_INSTITUTION_LOGIN_FAILURE,
  UPDATE_INSTITUTION_LOGIN_AUTH_FAILURE,

  DELETE_INSTITUTION_LOGIN_REQUEST,
  DELETE_INSTITUTION_LOGIN_SUCCESS,
  DELETE_INSTITUTION_LOGIN_FAILURE,

  SEARCH_FINANCIAL_INSTITUTION_REQUEST,
  SEARCH_FINANCIAL_INSTITUTION_SUCCESS,
  SEARCH_FINANCIAL_INSTITUTION_FAILURE,

  GET_ACCESS_TOKEN_REQUEST,
  GET_ACCESS_TOKEN_SUCCESS,
  GET_ACCESS_TOKEN_ERROR

} from '../actions/transactionActions';

const initialState = {
  transactionList: {},
  transactionsCount: 0,
  lastUpdated: "",
  enrollmentState: {},
  institutionsList: {},
  alertPreferences: {},
  financialInstitutions: {},
  financialInstitutionsById: {},
  popularFinancialInstitutions: {},
  searchFinancialInstitutions: {},
  paginatedTransactions: {},
  filteredTransactionList: {},
  addInstitutionLoginResponse: {},
  updateInstitutionLoginResponse: {},
  answerAddInstitutionLoginChallengeResponse: {},
  answerUpdateInstitutionLoginChallengeResponse: {},
  deleteInstitutionLoginStatus: {},
  dateOption: "Date",
  accountName: "Accounts"
};

export default function transactions(state = initialState, action = null) {
  switch (action.type) {
    case TRANSACTION_LIST_REQUEST:
      return Object.assign({}, state, {
        transactionRequestStatus: "loading",
        transactionList: {},
        transactionsCount: 0,
        lastUpdated: "",
      });
    case TRANSACTION_LIST_SUCCESS:
      return Object.assign({}, state, {
        transactionRequestStatus: "success",
        transactionList: action.transactionList,
        transactionsCount: action.transactionsCount,
        lastUpdated: action.lastUpdated,
        filteredTransactionList: {}
      });
    case TRANSACTION_OVERVIEW_SUCCESS:
      return Object.assign({}, state, {
        transactionList4Overview: action.transactionList4Overview
      });
    case TRANSACTION_LIST_FAILURE:
      return Object.assign({}, state, {
        transactionRequestStatus: "error",
        transactionList: {},
        transactionsCount: 0,
        lastUpdated: {}
      });
    case MEMBER_ENROLLMENT_REQUEST:
      return Object.assign({}, state, {
        enrollmentRequestStatus: "loading",
        enrollmentState: {}
      });
    case MEMBER_ENROLLMENT_SUCCESS:
      return Object.assign({}, state, {
        enrollmentRequestStatus: "success",
        enrollmentState: action.enrollmentState
      });
    case MEMBER_ENROLLMENT_FAILURE:
      return Object.assign({}, state, {
        enrollmentRequestStatus: "error",
        enrollmentState: {}
      });

    case MEMBER_ACCOUNTS_REQUEST:
      return Object.assign({}, state, {
        accountsRequestStatus: "loading",
        institutionsList: []
      });
    case MEMBER_ACCOUNTS_SUCCESS:
      return Object.assign({}, state, {
        accountsRequestStatus: "success",
        institutionsList: action.institutionsList,
        alertPreferences: action.alertPreferences
      });
    case MEMBER_ACCOUNTS_FAILURE:
      return Object.assign({}, state, {
        accountsRequestStatus: "error",
        institutionsList: []
      });

    case FINANCIAL_INSTITUTIONS_REQUEST:
      return Object.assign({}, state, {
        financialInstitutionsRequest: "loading"
      });
    case FINANCIAL_INSTITUTIONS_SUCCESS:
      return Object.assign({}, state, {
        financialInstitutionsRequest: "success",
        financialInstitutions: action.financialInstitutions
      });
    case FINANCIAL_INSTITUTIONS_FAILURE:
      return Object.assign({}, state, {
        financialInstitutionsRequest: "error"
      });

    case FINANCIAL_INSTITUTIONS_BY_ID_REQUEST:
      return Object.assign({}, state, {
        financialInstitutionsByIdRequest: "loading"
      });

    case FINANCIAL_INSTITUTIONS_BY_ID_SUCCESS:
      return Object.assign({}, state, {
        financialInstitutionsByIdRequest: "success",
        financialInstitutionsById: action.financialInstitutionsById
      });

    case FINANCIAL_INSTITUTIONS_BY_ID_FAILURE:
      return Object.assign({}, state, {
        financialInstitutionsByIdRequest: "error"
      });

    case POPULAR_FINANCIAL_INSTITUTIONS_REQUEST:
      return Object.assign({}, state, {
        popularFinancialInstitutionsRequest: "loading"
      });

    case POPULAR_FINANCIAL_INSTITUTIONS_SUCCESS:
      return Object.assign({}, state, {
        popularFinancialInstitutionsRequest: "success",
        popularFinancialInstitutions: action.popularFinancialInstitutions
      });
    case POPULAR_FINANCIAL_INSTITUTIONS_FAILURE:
      return Object.assign({}, state, {
        popularFinancialInstitutionsRequest: "error"
      });
    case PAGINATE_TRANSACTIONS:
      return Object.assign({}, state, {
        paginatedTransactions: action.paginatedTransactions
      });
    case FILTERED_TRANSACTIONS_BY_ACCOUNT_ID:
      return Object.assign({}, state, {
        filteredTransactionList: action.filteredTransactionList
      });
    case CURRENT_DATE_SELECTION:
      return Object.assign({}, state, {
        dateOption: action.dateOption
      });
    case CURRENT_ACCOUNT_SELECTION:
      return Object.assign({}, state, {
        accountName: action.accountName
      });

    case RESET_ADD_ACCOUNTS_MODAL:
      return Object.assign({}, state, {
        addInstitutionLoginRequestStatus: {},
        answerAddInstitutionLoginChallengeRequestStatus: {},
        addInstitutionLoginResponse: {},
        answerAddInstitutionLoginChallengeResponse: {},
        financialInstitutions: {},
        financialInstitutionsById: {},
        searchFinancialInstitutions: {},
        updateInstitutionLoginRequestStatus: {},
        updateInstitutionLoginResponse: {},
        statusCode: null,
        memSiteAccountId: null
      });

    case RESET_LOGIN_FORM:
      return Object.assign({}, state, {
        financialInstitutions: {},
        financialInstitutionsById: {}
      });

    case RESET_LOGIN_ERROR:
      return Object.assign({}, state, {
        addInstitutionLoginRequestStatus: {},
        updateInstitutionLoginRequestStatus: {},
        answerAddInstitutionLoginChallengeRequestStatus: {},
        addInstitutionLoginResponse: {},
        updateInstitutionLoginResponse: {},
        answerAddInstitutionLoginChallengeResponse: {},
        statusCode: action.statusCode,
        memSiteAccountId: action.memSiteAccountId
      });

    case RESET_CHALLENGE_QUESTION:
      return Object.assign({}, state, {
        answerAddInstitutionLoginChallengeRequestStatus: {},
        answerAddInstitutionLoginChallengeResponse: {}
      });

    case TXM_SET_ALERT_PREF_REQUEST:
      return Object.assign({}, state, {
        alertPreferencesRequestStatus: 'loading',
        alertPreferences: []
      });
    case TXM_SET_ALERT_PREF_SUCCESS:
      return Object.assign({}, state, {
        alertPreferencesRequestStatus: 'success',
        alertPreferences: action.alertPreference
      });
    case TXM_SET_ALERT_PREF_FAILURE:
      return Object.assign({}, state, {
        alertPreferencesRequestStatus: 'error',
      });

    case ADD_INSTITUTION_LOGIN_REQUEST:
      return Object.assign({}, state, {
        addInstitutionLoginRequestStatus: 'loading',
        addInstitutionLoginResponse: {}
      });
    case ADD_INSTITUTION_LOGIN_SUCCESS:
      return Object.assign({}, state, {
        addInstitutionLoginRequestStatus: 'success',
        addInstitutionLoginResponse: action.addInstitutionLoginResponse
      });
    case ADD_INSTITUTION_LOGIN_FAILURE:
      return Object.assign({}, state, {
        addInstitutionLoginRequestStatus: 'error',
        addInstitutionLoginResponse: action.addInstitutionLoginResponse
      });
    case ADD_INSTITUTION_LOGIN_AUTH_FAILURE:
      return Object.assign({}, state, {
        addInstitutionLoginRequestStatus: 'auth_error',
        addInstitutionLoginResponse: {}
      });

    case ANSWER_ADD_INSTITUTION_LOGIN_CHALLENGE_REQUEST:
      return Object.assign({}, state, {
        answerAddInstitutionLoginChallengeRequestStatus: 'loading',
        answerAddInstitutionLoginChallengeResponse: {}
      });
    case ANSWER_ADD_INSTITUTION_LOGIN_CHALLENGE_SUCCESS:
      return Object.assign({}, state, {
        answerAddInstitutionLoginChallengeRequestStatus: 'success',
        answerAddInstitutionLoginChallengeResponse: action.answerAddInstitutionLoginChallengeResponse
      });
    case ANSWER_ADD_INSTITUTION_LOGIN_CHALLENGE_FAILURE:
      return Object.assign({}, state, {
        answerAddInstitutionLoginChallengeRequestStatus: 'error',
        answerAddInstitutionLoginChallengeResponse: action.answerAddInstitutionLoginChallengeResponse
      });

    case UPDATE_INSTITUTION_LOGIN_REQUEST:
      return Object.assign({}, state, {
        updateInstitutionLoginRequestStatus: 'loading',
        updateInstitutionLoginResponse: {}
      });

    case UPDATE_INSTITUTION_LOGIN_SUCCESS:
      return Object.assign({}, state, {
        updateInstitutionLoginRequestStatus: 'success',
        updateInstitutionLoginResponse: action.updateInstitutionLoginResponse
      });

    case UPDATE_INSTITUTION_LOGIN_FAILURE:
      return Object.assign({}, state, {
        updateInstitutionLoginRequestStatus: 'error',
        updateInstitutionLoginResponse: action.updateInstitutionLoginResponse
      });

    case ANSWER_UPDATE_INSTITUTION_LOGIN_CHALLENGE_REQUEST:
      return Object.assign({}, state, {
        answerUpdateInstitutionLoginChallengeRequestStatus: 'loading',
        answerUpdateInstitutionLoginChallengeResponse: {}
      });
    case ANSWER_UPDATE_INSTITUTION_LOGIN_CHALLENGE_SUCCESS:
      return Object.assign({}, state, {
        answerUpdateInstitutionLoginChallengeRequestStatus: 'success',
        answerUpdateInstitutionLoginChallengeResponse: action.answerUpdateInstitutionLoginChallengeResponse
      });
    case ANSWER_UPDATE_INSTITUTION_LOGIN_CHALLENGE_FAILURE:
      return Object.assign({}, state, {
        answerUpdateInstitutionLoginChallengeRequestStatus: 'error',
        answerUpdateInstitutionLoginChallengeResponse: action.answerUpdateInstitutionLoginChallengeResponse
      });

    case UPDATE_INSTITUTION_LOGIN_AUTH_FAILURE:
      return state;

    case DELETE_INSTITUTION_LOGIN_REQUEST:
      return Object.assign({}, state, {
        deleteInstitutionLoginStatus: 'loading'
      });
    case DELETE_INSTITUTION_LOGIN_SUCCESS:
      return Object.assign({}, state, {
        delete_institution_login_response: action.payload,
        deleteInstitutionLoginStatus: 'success'
      });
    case DELETE_INSTITUTION_LOGIN_FAILURE:
      return Object.assign({}, state, {
        deleteInstitutionLoginStatus: 'error'
      });

    case SEARCH_FINANCIAL_INSTITUTION_REQUEST:
      return Object.assign({}, state, {
        searchFinancialInstitutionsRequest: "loading",
        searchFinancialInstitutions: {}
      });
    case SEARCH_FINANCIAL_INSTITUTION_SUCCESS:
      return Object.assign({}, state, {
        searchFinancialInstitutionsRequest: "success",
        searchFinancialInstitutions: action.searchFinancialInstitutions
      });
    case SEARCH_FINANCIAL_INSTITUTION_FAILURE:
      return Object.assign({}, state, {
        searchFinancialInstitutionsRequest: "error",
        searchFinancialInstitutions: {}
      });

    case GET_ACCESS_TOKEN_REQUEST:
      return Object.assign({}, state, {
        getAccessTokenResult: {}
      });
    case GET_ACCESS_TOKEN_SUCCESS:
      return Object.assign({}, state, {
        getAccessTokenResult: action.getAccessTokenResult
      });
    case GET_ACCESS_TOKEN_ERROR:
      return Object.assign({}, state, {
        getAccessTokenResult: {}
      });

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/transactionReducers.js